import { UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Classification, Severity, SimpleAsset, Status } from 'queries/assets/contract';

export type GenericQueryOptions<TData> = Omit<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  UseQueryOptions<TData, AxiosError, TData, any[]>,
  'queryKey' | 'queryFn'
>;

export interface EventByIdProps {
  eventId?: string;
}

export interface EventListProps {
  modelName?: string;
  statusId?: number;
  assetId?: number | string;
  startDate?: string;
  endDate?: string;
  showAnalysis?: boolean;
  showStatus?: boolean;
  showAsset?: boolean;
  showTags?: boolean;
}

export interface EventListParams {
  model_name?: string;
  status_id?: number;
  asset_id?: number | string;
  date_from?: string;
  date_to?: string;
  show_analysis?: boolean;
  show_status?: boolean;
  show_asset?: boolean;
  show_tags?: boolean;
}

export interface EventCountRootProps {
  onlyOpen?: boolean;
}

export type ActiveTab = 'ALL' | 'OPEN' | 'CLOSED';

export interface EventCountRootParams {
  only_open?: boolean;
}
export type EventStatus = 'OPEN' | 'CLOSED';
export type EventFilters = Omit<TableFilters, 'status'> & {
  status?: EventStatus;
  alarms_without_cds?: boolean;
};

export interface EventCountProps extends EventCountRootProps {
  assetId?: string | number;
}

export interface AggregatedAlarms {
  alarmId?: string | number;
}

export interface EventCommentMutationProps extends EventByIdProps {
  comment: string;
}
export interface EventCommentMutationPayload {
  comment: string;
}

export enum NextStep {
  ATTACH = 'ATTACH_ALARM_TO_AN_EXISTING_CASE',
  CREATE = 'CREATE_NEW_CASE_AND_ATTACH_ALARM',
  NO_ACTION = 'NO_ACTION',
}

export type EventItem = {
  children?: EventItem[];
  isChild?: boolean;
  alarm_datetime_end: string;
  alarm_datetime_start: string;
  start_date?: string;
  end_date?: string;
  asset: SimpleAsset;
  item?: SimpleAsset;
  classification: Classification;
  closed_at?: string | null;
  closed_by?: string;
  description: string;
  duration: string;
  id: string;
  method: string;
  name: string;
  next_step: NextStep;
  number_of_aggregated_alarms: number;
  prognosis: string;
  severity: Severity;
  status: Status;
  not_useful_reason: string;
  category?: string;
  comments?: string;
  model_name?: string;
  is_cd_treatment_required?: boolean;
  is_automatic?: boolean;
  is_able_to_operate?: boolean;
};

export type EventItemExtended = EventItem & {
  is_automatic_blocked?: boolean;
  is_assigned_to_case?: boolean;
  assignedChecks?: number;
};

export type EventItemPayload = {
  events: EventItem[];
};
export type EventSimilar = {
  classification: Classification | null;
  comments: string | null;
  event_id: string;
  start_date: string;
  end_date: string;
};

export type EventSimilarPayload = {
  events: EventSimilar[];
};

export type AggregatedAlarmsPayload = {
  alarms: EventItem[];
};

export interface EventUpdateMutationPayload {
  classification: string;
  next_step?: NextStep;
  not_useful_reason?: string;
  comments?: string;
  status?: string;
  is_cd_treatment_required?: boolean;
}

export interface EventUpdateMutationProps extends EventUpdateMutationPayload {
  eventId: string;
}

export interface EventBatchUpdateMutationProps extends EventUpdateMutationPayload {
  event_ids: string[];
}

export interface FilterOptionsResponse {
  categories: { value: string; label: string }[];
  vessels?: { id: string; name: string }[];
  assets?: { id: string; name: string }[];
}

export type categories = {
  name: string;
};

export type PIAttribute = {
  categories: categories[];
  data_source: string;
  data_type: string;
  id: string;
  name: string;
  value: string;
};

export type PIAttributes = {
  attributes: PIAttribute[];
};

export type PIparams = {
  name: string;
};
export type AutomaticAckInfo = {
  summary: {
    events: {
      total: number;
    };
    models: {
      total: number;
    };
  };
};

export type AckModel = {
  id: string;
  case_id: string;
  case_name: string;
  asset_id: string;
  asset_name: string;
  model_id: string;
  model_name: string;
  model_label: string;
  event_type: string;
  number_of_alarms: number;
};
